import React from "react";
import { Link } from "react-router-dom";
import pcCareLogo from "../assests/images/pccarelogo.jpg";

const Footer = () => {
  return (
    <footer className="w-full bg-[#351F72] text-white">

      {/* 🔹 Social Section */}
      <div className="bg-[#F3802C]">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-center md:text-left">
            Get connected with us on social networks
          </p>

        
        
        </div>
      </div>

      {/* 🔹 Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

        {/* Company */}
        <div>
          {/* 🔹 Logo instead of H3 */}
          <img
            src={pcCareLogo}
            alt="PC Care Logo"
            className="h-12 w-12 mb-4 object-contain"
          />

          <p className="text-sm text-white/80 leading-relaxed">
            PC Care is a trusted second-hand laptop & computer store.
            We provide tested, reliable devices with warranty & support.
          </p>
        </div>

        {/* Pages */}
        <div>
          <h3 className="text-lg font-semibold text-[#FFC107] mb-4">
            Pages
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-[#F3802C]">
                Home
              </Link>
            </li>
            <li>
              <Link to="/products" className="hover:text-[#F3802C]">
                Products
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-[#F3802C]">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-[#F3802C]">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Policies */}
        <div>
          <h3 className="text-lg font-semibold text-[#FFC107] mb-4">
            Policies
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/shipping-policy" className="hover:text-[#F3802C]">
                Shipping Policy
              </Link>
            </li>
            <li>
              <Link to="/return-policy" className="hover:text-[#F3802C]">
                Return Policy
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" className="hover:text-[#F3802C]">
                Refund & Cancellation Policy
              </Link>
            </li>
            <li>
              <Link to="/warranty-policy" className="hover:text-[#F3802C]">
                Warranty Policy
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="hover:text-[#F3802C]">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-conditions" className="hover:text-[#F3802C]">
                Terms & Conditions
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-semibold text-[#FFC107] mb-4">
            Contact
          </h3>
          <ul className="space-y-3 text-sm text-white/80">

            <li className="flex items-center gap-3">
              <i className="fas fa-envelope text-[#F3802C]"></i>
              <a
                href="mailto:info@pccarecomputers.com"
                className="hover:text-[#FFC107] transition"
              >
                info@pccarecomputers.com
              </a>
            </li>

            <li className="flex items-center gap-3">
              <i className="fas fa-phone text-[#F3802C]"></i>
              <a
                href="tel:+919238264606"
                className="hover:text-[#FFC107] transition"
              >
                +91 9238264606
              </a>
            </li>

            <li className="flex items-center gap-3">
              <i className="fas fa-map-marker-alt text-[#F3802C]"></i>
              <a
                href="https://www.google.com/maps?q=23.168639,79.931806"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#FFC107] transition"
              >
                Pc Care Computer, 1035 Malviya Chowk, Infront Of Yatayat Thana, Jabalpur (Mp) 482001
              </a>
            </li>

          </ul>
        </div>

      </div>

      {/* 🔹 Bottom Bar */}
      <div className="bg-[#2c185d] text-center text-sm py-4">
        © {new Date().getFullYear()} PC Care. All Rights Reserved.
        <div className="text-xs text-gray-100 mt-1">
          Designed & Developed by{" "}
          <a
            href="https://yashsoftsolution.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#F3802C]"
          >
            Yashsoft Solution
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
